import type { FC } from 'react';

import type { FilesKeyframeSchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/files';
import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';
import { isLiveAsset } from '@iconik-io/shared-lib/src/utils/is_live_asset';

import { parseObjectIconInfo } from '../../../utils/parse_object_icon_info';
import { ObjectIconThumbnail } from '../../object_icon_thumbnail/object_icon_thumbnail';
import { SearchWarningSign } from '../../search_warning_sign/search_warning_sign';
import { ThumbnailDisplay } from './thumbnail_display';

type Props = {
  value?: Partial<FilesKeyframeSchemaWithIdNullable>[];
  waiting?: boolean;
  item: SearchItemEntity;
  showWarningIcon?: boolean;
};

const SearchItemsThumbnail: FC<Props> = (props) => {
  const { value, item } = props;
  const objectIconInfo = parseObjectIconInfo(item);
  return (
    <ThumbnailDisplay
      keyframes={value}
      allowGrowing={isLiveAsset(item)}
      fallback={<ObjectIconThumbnail objectIconInfo={objectIconInfo} />}
      warningSign={
        props.showWarningIcon && item.warning ? (
          <SearchWarningSign item={item} />
        ) : undefined
      }
    />
  );
};

export default SearchItemsThumbnail;
